import { render } from "./ContractsDashboard.vue?vue&type=template&id=ec561eb4&scoped=true"
import script from "./ContractsDashboard.vue?vue&type=script&lang=js"
export * from "./ContractsDashboard.vue?vue&type=script&lang=js"

import "./ContractsDashboard.vue?vue&type=style&index=0&id=ec561eb4&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec561eb4"]])

export default __exports__